import SvgIcon from "@mui/material/SvgIcon";
import PictureAsPdfSvg from "../live-svg/picture-as-pdf.svg";
import React from "react";

export function PictureAsPdfIcon(props) {
    return (
        <SvgIcon {...props}>
            <PictureAsPdfSvg color={props.color || "#36415D"}/>
        </SvgIcon>
    )
}
